var LoadErrorStatus;
(function (LoadErrorStatus) {
    LoadErrorStatus[LoadErrorStatus["None"] = 0] = "None";
    LoadErrorStatus[LoadErrorStatus["AccessDenied"] = 1] = "AccessDenied";
    LoadErrorStatus[LoadErrorStatus["Other"] = 2] = "Other";
})(LoadErrorStatus || (LoadErrorStatus = {}));
export default LoadErrorStatus;
//# sourceMappingURL=LoadErrorStatus.js.map